/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prettier/prettier */
import styled from "styled-components";
import React, { useState, useEffect } from "react";

export default function BlockElement() {
  const [height, setHeight] = useState(window.pageYOffset);
  console.log("got to block element");
  function handleScroll() {
    setHeight(window.pageYOffset);
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <>
      <div
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "flex-end",
        }}
      >
        <div
          style={{
            zIndex: "9999",
            background: "black",
            width: "100%",
            position: "fixed",
            height: `calc(100% - 54px + ${height}px)`,
            opacity: "0.25",
          }}
        />
      </div>
    </>
  );
}
